import supabaseClient from '@/api/supabaseClient.ts';
import { useQuery } from '@tanstack/react-query';
import { FunctionsHttpError } from '@supabase/supabase-js';
import { BackendErrorResponse } from '@/types/response/BackendErrorResponse';

export type BookingRequest = {
  id: string;
  user_id: string;
  carer_id: string;
  status: string;
  start_date?: string;
  end_date?: string;
  start_time?: string;
  end_time?: string;
  care_type?: string;
  notes?: string;
  decline_reason?: string;
  created_at: string;
  updated_at: string;
  other_user_name: string;
  other_user_photo?: string;
  is_requester: boolean;
  has_review: boolean;
};

const useBookingRequests = () => {
  const queryFn = async (): Promise<BookingRequest[]> => {
    const { data, error } = await supabaseClient.functions.invoke('get_booking_requests', {
      method: 'POST',
    });

    if (error) {
      if (error instanceof FunctionsHttpError) {
        const err: BackendErrorResponse = await error.context.json();
        throw new Error(err.errors.join(', '));
      }
      throw new Error((error as Error).message);
    }

    return data?.data?.bookings || [];
  };

  return useQuery<BookingRequest[], Error>({
    queryKey: ['bookingRequests'],
    queryFn,
  });
};

export default useBookingRequests;
